import React, { useState, useEffect } from "react";
// import "../css/Blog.css";
import NAV from "./nav";
import Carousel from "./carousel";
import {contact, fetchBlog} from "../api";
import PriceScroller from "../components/pricescroll";
import {getCookie} from "../resources/utilities";
import PlanSelectionPage from "../components/payment/plan_select";

const Subscription = () => {

  return (
    <div>
          {/*<!-- Navbar & Hero Start -->*/}
        <div class="container-fluid position-relative p-0">
            <NAV activetag="contact"/>
            {/*<!-- Header Start -->*/}
            <div className="container-fluid bg-breadcrumb">
                {/*<div class="container text-center py-5" style={{maxwidth: '500px'}}>*/}
                <div className="container text-center py-2" style={{maxwidth: '500px', maxHeight: '20px'}}>
                    <h4 className="text-white display-4 mb-4 wow fadeInDown" data-wow-delay="0.1s">User Portal </h4>
                    {/*<ol class="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">*/}
                    {/*    <li class="breadcrumb-item"><a href="index1.html">Home</a></li>*/}
                    {/*    <li class="breadcrumb-item"><a href="#">Pages</a></li>*/}
                    {/*    <li class="breadcrumb-item active text-primary">Service</li>*/}
                    {/*</ol>*/}
                </div>
            </div>
        </div>
            {/*<!-- Header End -->*/}
        {/*<!-- Navbar & Hero End -->*/}
      {/* 2-Column Layout */}
        <div className="container-fluid service py-5">
            <div className="container py-5">
                {/*<div className="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.6s">*/}
                    {/*<div className="service-item" >*/}
                        <PlanSelectionPage/>
                    {/*</div>*/}
                {/*</div>*/}
            </div>
        </div>
  </div>
  );
};
export default Subscription;
